import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UITooltip from 'UIComponents/tooltip/UITooltip';

/**
 * A lifecycle stage option represented as a checkbox.
 */
const FacebookCapiLifecycleStageOption = (_ref) => {
  let {
    isChecked,
    isEnabled,
    lifecycleStage,
    handleSelectLifecycleStage
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["isChecked", "isEnabled", "lifecycleStage", "handleSelectLifecycleStage"]);

  return /*#__PURE__*/_jsx(UITooltip, {
    disabled: isEnabled,
    placement: "left",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "events.creation.CRM_EVENT.lifecycleStages.alreadySyncingTooltip"
    }),
    children: /*#__PURE__*/_jsx(UICheckbox, Object.assign({
      "data-test-id": `fb-capi-lifecycle-stage-${lifecycleStage}`,
      checked: isChecked,
      disabled: !isEnabled,
      onChange: event => {
        handleSelectLifecycleStage(lifecycleStage, event.target.checked);
      },
      value: lifecycleStage // Spread props to fix UIFormControl warning:
      // "For accessibility props to work correctly, the direct descendant should be a valid form element."

    }, rest, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `events.creation.CRM_EVENT.lifecycleStages.networkEvents.FACEBOOK_CAPI.${lifecycleStage}`
      })
    }), lifecycleStage)
  }, `${lifecycleStage}-tooltip`);
};

export default FacebookCapiLifecycleStageOption;